import Router from './shared/Router';

const App = () => {
  return <Router></Router>;
};

export default App;
